import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import { FaLocationDot, FaMapLocationDot } from 'react-icons/fa6';
import { GiWeightScale } from 'react-icons/gi';
import { IoBedOutline } from 'react-icons/io5';
import data from "../../data/mainData.json";


class ProductListingV1 extends Component {

	render() {
		let publicUrl = process.env.PUBLIC_URL + '/'

		return <div>
			<div className="ltn__product-slider-area ltn__product-gutter pt-50 pb-70">
				<div className="container">
					{/* <div className="row">
						<div className="col-lg-12">
							<div className="section-title-area ltn__section-title-2--- text-center">
								<h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">Property</h6>
								<h1 className="section-title ltn__secondary-color">Our Projects</h1>
							</div>
						</div>
					</div> */}

					{/* <div className="row mb-5">
						<div className="col-md-12">
							<ul
								className="nav justify-content-center"
								role="tablist"
								style={{
									borderBottom: "none",
									gap: "10px",
									flexWrap: "nowrap",
									overflowX: "auto",
									whiteSpace: "nowrap",
									WebkitOverflowScrolling: "touch"
								}}
							>
								<li className="nav-item" style={{ marginBottom: "10px" }}>
									<a
										className="nav-link active"
										data-toggle="tab"
										href="#"
										role="tab"
										style={{
											border: "none",
											background: "#e0e0e0",
											color: "#000",
											padding: "12px 30px",
											fontSize: "15px",
											borderRadius: "4px",
											minWidth: "150px",
											textAlign: "center",
											// fontWeight: "600"
										}}
									>
										Cheran Nagar <br /><span className='text-primary'>Vanjipalayam</span>
									</a>
								</li>

								<li className="nav-item" style={{ marginBottom: "10px" }}>
									<a
										className="nav-link"
										data-toggle="tab"
										href="#"
										role="tab"
										style={{
											border: "none",
											background: "#e0e0e0",
											color: "#000",
											padding: "12px 30px",
											fontSize: "15px",
											borderRadius: "4px",
											minWidth: "150px",
											textAlign: "center"
										}}
									>
										Cheran Enrich <br /><span className='text-primary'>College Road</span>
									</a>
								</li>

								<li className="nav-item" style={{ marginBottom: "10px" }}>
									<a
										className="nav-link"
										data-toggle="tab"
										href="#"
										role="tab"
										style={{
											border: "none",
											background: "#e0e0e0",
											color: "#000",
											padding: "12px 30px",
											fontSize: "15px",
											borderRadius: "4px",
											minWidth: "150px",
											textAlign: "center"
										}}
									>
										Royal Avenue<br /><span className='text-primary'>Mudalipalayam</span>
									</a>
								</li>

								<li className="nav-item" style={{ marginBottom: "10px" }}>
									<a
										className="nav-link"
										data-toggle="tab"
										href="#"
										role="tab"
										style={{
											border: "none",
											background: "#e0e0e0",
											color: "#000",
											padding: "12px 30px",
											fontSize: "15px",
											borderRadius: "4px",
											minWidth: "150px",
											textAlign: "center"
										}}
									>
										Royal Park <br /><span className='text-primary'>Mudalipalayam</span>
									</a>
								</li>

								<li className="nav-item" style={{ marginBottom: "10px" }}>
									<a
										className="nav-link"
										data-toggle="tab"
										href="#"
										role="tab"
										style={{
											border: "none",
											background: "#e0e0e0",
											color: "#000",
											padding: "12px 30px",
											fontSize: "15px",
											borderRadius: "4px",
											minWidth: "150px",
											textAlign: "center"
										}}
									>
										Royal Enclave<br /><span className='text-primary'>Mudalipalayam</span>
									</a>
								</li>

								<li className="nav-item" style={{ marginBottom: "10px" }}>
									<a
										className="nav-link"
										data-toggle="tab"
										href="#pune"
										role="tab"
										style={{
											border: "none",
											background: "#e0e0e0",
											color: "#000",
											padding: "12px 30px",
											fontSize: "15px",
											borderRadius: "4px",
											minWidth: "150px",
											textAlign: "center"
										}}
									>
										Silver Spring<br /><span className='text-primary'>Palangarai</span>
									</a>
								</li>
								
							</ul>
						</div>
					</div> */}


					<div className="row ltn__product-slider-item-three-active--- slick-arrow-1">
						{data?.properties?.products.map(item => (
							<div key={item.slug_name} className="col-xl-4 col-sm-6 col-12">
								<div className="ltn__product-item ltn__product-item-4">
									<div
										className="product-img go-top"
										style={{ position: "relative"}}
									>
										<Link to={`/project/${item.slug_name}`}>
											<img src={item?.image} alt="#" />
										</Link>
										<div className="product-badge">
											<ul>
												<li className="sale-badge bg-green---">{item?.type}</li>
											</ul>
										</div>

									</div>

									<div className="mx-3">
										{/* <div className="product-badge">
											<ul>
											<li className="sale-badg">{item.type}</li>
											</ul>
										</div> */}

										<div className="d-flex flex-column">
											<h5 className="mt-2 mb-0">
												<Link to={`/project/${item.slug_name}`}>{item.title}</Link>
											</h5>
											<small className="text-muted mb-2">{item.location}</small>
										</div>


										<div className="">
											<ul>
												{/* <li className="mb-0 mt-0">
													<Link to={`/project/${item.slug_name}`}>
														<FaLocationDot /> {item.location}
													</Link>
												</li> */}
												<li className="mb-0 mt-0">
												<Link
													to={`/project/${item.slug_name}`}
													className="d-flex align-items-start"
												>
													<FaMapLocationDot className="me-2 mt-1 flex-shrink-0" />
													<span className="text-wrap">
													{item.address}
													</span>
												</Link>
												</li>

												<li className="mb-0 mt-0">
													<Link to={`/project/${item.slug_name}`}>
														<GiWeightScale /> {item.totalsite}
													</Link>
												</li>
												{/* <li className="mb-0 mt-0">
													<Link to={`/project/${item.slug_name}`}>
														<IoBedOutline /> {item.beds}
													</Link>
												</li> */}
											</ul>
										</div>

										{/* <ul className="ltn__plot-brief">
											<li><span>{item.beds}</span> Bed</li>
											<li><span>{item.baths}</span> Bath</li>
											<li><span>{item.area}</span> Square Ft</li>
										</ul> */}
									</div>



									<div className="product-info-bottom">
										<div className="product-price fs-6 mb-0">
											<Link to={`/project/${item.slug_name}`}>
												<span className=''>View More</span>
											</Link>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>

				</div>
			</div>
			<div className="ltn__modal-area ltn__add-to-cart-modal-area">
				<div className="modal fade" id="liton_wishlist_modal" tabIndex={-1}>
					<div className="modal-dialog modal-md" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="ltn__quick-view-modal-inner">
									<div className="modal-product-item">
										<div className="row">
											<div className="col-12">
												<div className="modal-product-img">
													<img src={publicUrl + "assets/img/product/7.png"} alt="#" />
												</div>
												<div className="modal-product-info go-top">
													<h5><Link to="">Brake Conversion Kit</Link></h5>
													<p className="added-cart"><i className="fa fa-check-circle" />  Successfully added to your Wishlist</p>
													<div className="btn-wrapper">
														<Link to="/wishlist" className="theme-btn-1 btn btn-effect-1">View Wishlist</Link>
													</div>
												</div>
												<div className="additional-info d-none">
													<p>We want to give you <b>10% discount</b> for your first order, <br />  Use discount code at checkout</p>
													<div className="payment-method">
														<img src={publicUrl + "assets/img/icons/payment.png"} alt="#" />
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="ltn__modal-area ltn__quick-view-modal-area">
				<div className="modal fade" id="quick_view_modal" tabIndex={-1}>
					<div className="modal-dialog modal-lg" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
									{/* <i class="fas fa-times"></i> */}
								</button>
							</div>
							<div className="modal-body">
								<div className="ltn__quick-view-modal-inner">
									<div className="modal-product-item">
										<div className="row">
											<div className="col-lg-6 col-12">
												<div className="modal-product-img">
													<img src={publicUrl + "assets/img/product/4.png"} alt="#" />
												</div>
											</div>
											<div className="col-lg-6 col-12">
												<div className="modal-product-info">
													<div className="product-ratting">
														<ul>
															<li><a href="#"><i className="fas fa-star" /></a></li>
															<li><a href="#"><i className="fas fa-star" /></a></li>
															<li><a href="#"><i className="fas fa-star" /></a></li>
															<li><a href="#"><i className="fas fa-star-half-alt" /></a></li>
															<li><a href="#"><i className="far fa-star" /></a></li>
															<li className="review-total"> <a href="#"> ( 95 Reviews )</a></li>
														</ul>
													</div>
													<h3>Brake Conversion Kit</h3>
													<div className="product-price">
														<span>$149.00</span>
														<del>$165.00</del>
													</div>
													<div className="modal-product-meta ltn__product-details-menu-1">
														<ul>
															<li>
																<strong>Categories:</strong>
																<span className="go-top">
																	<Link to="/blog">Parts</Link>
																	<Link to="/blog">Car</Link>
																	<Link to="/blog">Seat</Link>
																	<Link to="/blog">Cover</Link>
																</span>
															</li>
														</ul>
													</div>
													<div className="ltn__product-details-menu-2">
														<ul>
															<li>
																<div className="cart-plus-minus">
																	<input type="text" defaultValue="02" name="qtybutton" className="cart-plus-minus-box" />
																</div>
															</li>
															<li>
																<a href="#" className="theme-btn-1 btn btn-effect-1" title="Add to Cart" data-bs-toggle="modal" data-bs-target="#add_to_cart_modal">
																	<i className="fas fa-shopping-cart" />
																	<span>ADD TO CART</span>
																</a>
															</li>
														</ul>
													</div>
													<hr />
													<div className="ltn__social-media">
														<ul>
															<li>Share:</li>
															<li><a href="#" title="Facebook"><i className="fab fa-facebook-f" /></a></li>
															<li><a href="#" title="Twitter"><i className="fab fa-twitter" /></a></li>
															<li><a href="#" title="Linkedin"><i className="fab fa-linkedin" /></a></li>
															<li><a href="#" title="Instagram"><i className="fab fa-instagram" /></a></li>
														</ul>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="ltn__modal-area ltn__add-to-cart-modal-area">
				<div className="modal fade" id="add_to_cart_modal" tabIndex={-1}>
					<div className="modal-dialog modal-md" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="ltn__quick-view-modal-inner">
									<div className="modal-product-item">
										<div className="row">
											<div className="col-12">
												<div className="modal-product-img">
													<img src={publicUrl + "assets/img/product/1.png"} alt="#" />
												</div>
												<div className="modal-product-info go-top">
													<h5 className="go-top"><Link to="">Brake Conversion Kit</Link></h5>
													<p className="added-cart"><i className="fa fa-check-circle" />Successfully added to your Cart</p>
													<div className="btn-wrapper">
														<Link to="/cart" className="theme-btn-1 btn btn-effect-1">View Cart</Link>
														<Link to="/checkout" className="theme-btn-2 btn btn-effect-2">Checkout</Link>
													</div>
												</div>
												{/* additional-info */}
												<div className="additional-info d-none">
													<p>We want to give you <b>10% discount</b> for your first order, <br />  Use discount code at checkout</p>
													<div className="payment-method">
														<img src={publicUrl + "assets/img/icons/payment.png"} alt="#" />
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
}

export default ProductListingV1